import { FC } from 'react'
import RequestStatus from '@constants/request_statuses'
import Status from '@constants/request_statuses'
import Button from '@components/Button'
import SpinnerButton from '@components/forms/spinner_button'
import { SerializableError } from '@app-types/general'
import ChangesList from './ChangesList'

interface UnsavedChangesProps {
  resourceType: string
  resourceId: string
  currentOptions: Record<string, unknown>
  stagedOptions: Record<string, unknown>
  initialChanges: Record<string, unknown>
  showChangesList?: boolean
  onSave: (resourceType: string, resourceId: string, stagedOptions: Record<string, unknown>) => void
  onReset: (resourceType: string, resourceId: string) => void
  status?: RequestStatus
  error?: SerializableError
}

const UnsavedChanges: FC<UnsavedChangesProps> = ({
  resourceType,
  resourceId,
  currentOptions,
  stagedOptions,
  initialChanges,
  showChangesList = false,
  onSave,
  onReset,
  status,
  error,
}) => {
  const hasUnsavedChanges = Object.keys(stagedOptions).length > 0

  const handleSave = () => {
    onSave(resourceType, resourceId, stagedOptions)
  }

  const handleReset = () => {
    onReset(resourceType, resourceId)
  }

  const getChanges = () => {
    return <ChangesList stagedOptions={stagedOptions} initialChanges={initialChanges} currentOptions={currentOptions} />
  }

  const getErrorMessage = () => {
    if (error) {
      return <div className="notice notice--error">{error.message}</div>
    }
  }

  const disableSubmit = status === Status.LOADING

  if (hasUnsavedChanges) {
    return (
      <div className="unsaved-changes notice notice--mini">
        <div className="unsaved-changes__heading">You have unsaved changes</div>
        <div className="form">
          <div className="form-group form-group-buttons form-group-buttons--left">
            {error && getErrorMessage()}
            <div className="form-group-buttons__container">
              <SpinnerButton className="btn btn--primary" onClick={handleSave} disabled={disableSubmit}>
                Save now
              </SpinnerButton>
              <Button className="btn btn--secondary" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
        {showChangesList && getChanges()}
      </div>
    )
  }

  return null
}

export default UnsavedChanges
